var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionBoxAdvanced(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 18L7.45312 16.9688L10.5469 14.9062H15.7031H17.25V13.3594V3.04688V1.5H15.7031H2.29688H0.75V3.04688V13.3594V14.9062H2.29688H4.35938H5.90625V16.1405V16.4531V18ZM9.68965 13.6204L7.45312 15.1093V14.9062V13.3594H5.90625H2.29688V3.04688H15.7031V13.3594H10.5469H10.0796L9.68965 13.6204ZM6.16406 5.88281V6.09229H7.71094V5.88281C7.71094 5.74102 7.82695 5.625 7.96875 5.625H9.80244C10.0731 5.625 10.2891 5.84414 10.2891 6.11162C10.2891 6.28564 10.1956 6.44678 10.0441 6.53379L8.6165 7.35234L8.22656 7.57793V8.02588V8.71875V9.49219H9.77344V8.71875V8.47383L10.8144 7.87764C11.446 7.51348 11.8359 6.83994 11.8359 6.11162C11.8359 4.98691 10.9239 4.07812 9.80244 4.07812H7.96875C6.97295 4.07812 6.16406 4.88701 6.16406 5.88281ZM8.22656 10.7812V12.3281H9.77344V10.7812H8.22656Z",
    fill: "#11AB7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBoxAdvanced);
export default __webpack_public_path__ + "static/media/QuestionBoxAdvanced.fc8790d70d49265cd8a3027069d2e790.svg";
export { ForwardRef as ReactComponent };